import script from "./svgBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./svgBody.vue?vue&type=script&setup=true&lang=ts"

import "./svgBody.vue?vue&type=style&index=0&id=df183f3e&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df183f3e"]])

export default __exports__